import { ABTestingGAUserPropertiesContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const FirebaseABTestingUserPropertiesProvider =
  createStaticContextProvider(
    ABTestingGAUserPropertiesContext,
    lazyValue(() =>
      import("./ab-testing-ga-user-properties").then(
        (module) => module.abTestingGAUserProperties,
      ),
    ),
  );
